/* ═══════════════════════════════════════════════════════════════
   SALIHA — Gift Box Configurator · M6
   3-step flow + Ready-made box flow + Notify modal + Resume banner
   ─────────────────────────────────────────────────────────────
   M6 changes:
     · 3 step: 1 Occasione + Tipo Box · 2 Prodotti · 3 Riepilogo + Biglietto
     · Biglietto obbligatorio (no gift toggle): gate su "Aggiungi al carrello"
     · Confezione: surcharge per livello (Classica +€10 / Premium +€25),
       mostrato nel riepilogo prezzo (line item packaging in tranche futura)
     · PRESETS per occasione — non ancora usati per ordinare lo step prodotti
     · Persistence: localStorage v3 with TTL 7 days + resume banner
     · Mobile sticky strip: totale + counter + CTA full-width
   IIFE namespace SALIHA_GB · localStorage 'saliha_giftbox_v3'
   ═══════════════════════════════════════════════════════════════ */
;(function SALIHA_GB() {
  'use strict';

  if (window.__SALIHA_GB_INIT__) return;
  window.__SALIHA_GB_INIT__ = true;

  /* ─── Constants ───────────────────────────────────────── */
  var STORAGE_KEY = 'saliha_giftbox_v3';
  var TTL_MS = 7 * 24 * 60 * 60 * 1000;
  var VERSION = 'M7';

  /* ─── Data (default; override via window.SALIHA_GIFTBOX_*) ── */
  var OCCASIONS = window.SALIHA_GIFTBOX_OCCASIONS || [
    { id: 'nuova-sorella', label: 'Nuova Sorella',      glyph: '◇' },
    { id: 'nikah',         label: 'Nikah · Matrimonio', glyph: '❀' },
    { id: 'nascita',       label: 'Nascita · Aqiqah',   glyph: '✿' },
    { id: 'ramadan',       label: 'Ramadan',            glyph: '☾' },
    { id: 'eid',           label: 'Eid',                glyph: '✦' },
    { id: 'altro',         label: 'Un pensiero',        glyph: '✎' }
  ];

  var LEVELS = window.SALIHA_GIFTBOX_LEVELS || [
    { id: 'classica', label: 'Box Classica', glyph: '✦', itemsLabel: 'fino a 5 prodotti', minItems: 1, maxItems: 5, surcharge: 10, priceRange: 'Confezione +€10', blurb: 'Scatola elegante color sabbia con biglietto in calligrafia. Il regalo curato, essenziale.' },
    { id: 'premium',  label: 'Box Premium',  glyph: '❀', itemsLabel: 'fino a 8 prodotti', minItems: 1, maxItems: 8, surcharge: 25, priceRange: 'Confezione +€25', blurb: 'Scatola velvet con magneti, riusabile, e tre pezzi in più. L\'unboxing che resta nella casa nuova.' }
  ];

  var PRODUCTS = window.SALIHA_GIFTBOX_PRODUCTS || [];
  var CURATED = window.SALIHA_GIFTBOX_CURATED || [];
  var PACKAGING = window.SALIHA_GIFTBOX_PACKAGING || {};
  var CATEGORIES = window.SALIHA_GIFTBOX_CATEGORIES || [
    { id: 'devozionale',      label: 'Devozionale' },
    { id: 'sunnah-lifestyle', label: 'Sunnah' },
    { id: 'hijab',            label: 'Hijab' },
    { id: 'khimar',           label: 'Khimar' },
    { id: 'niqab',            label: 'Niqab' },
    { id: 'accessori',        label: 'Accessori' }
  ];

  /* Preset prodotti consigliati per occasione (handle ordinati).
     Non ancora usati per ordinare lo step prodotti in questa tranche. */
  var PRESETS = window.SALIHA_GIFTBOX_PRESETS || {
    'nuova-sorella': ['abaya-nera-base-daily','hijab-jersey-modal-maxi-saliha-core','tappeto-preghiera-comfort-80-120-cm','tasbih-33-grani-base','quran-tascabile-italiano-arabo','sotto-hijab-bonnet-premium'],
    'nikah':         ['tappeto-preghiera-couple-set-2-pz','abaya-open-front-sage','diamond-chiffon-khimar-2-layer','quran-tascabile-italiano-arabo','tasbih-33-grani-base','hijab-chiffon-premium-estate'],
    'nascita':       ['quran-tascabile-italiano-arabo','tasbih-33-grani-base','hijab-jersey-modal-maxi-saliha-core','tappeto-preghiera-comfort-80-120-cm','sotto-hijab-bonnet-premium'],
    'ramadan':       ['tappeto-preghiera-comfort-80-120-cm','tasbih-33-grani-base','quran-tascabile-italiano-arabo','hijab-cotton-crinkle-summer','sotto-hijab-bonnet-premium','spille-magnetiche-hijab-set-3-pz'],
    'eid':           ['hijab-chiffon-premium-estate','abaya-open-front-mocha','diamond-chiffon-khimar-2-layer','tasbih-33-grani-base','spille-magnetiche-hijab-set-3-pz','quran-tascabile-italiano-arabo']
  };

  // FAQ content lives in sections/saliha-gift-box-page.liquid as static SSR markup
  // (single source of truth, SEO-indexable, JS-resilient). Empty array kept so
  // renderFaq() remains a no-op when static markup is present.
  var FAQS = [];

  /* ─── State ──────────────────────────────────────────── */
  var state = {
    step: 1,
    occasion: null,
    occasionOther: '',                   // testo libero quando occasion === 'altro'
    level: null,
    items: {},            // { variantId: { qty, name, price, image, productId, variantTitle, isAddon? } }
    activeCategory: null,
    recipient: '',
    message: '',
    from: '',
    boxMode: 'custom',                   // 'custom' | 'curated:<boxId>'
    expandedProductId: null              // id prodotto con expansion card aperta
  };

  /* ─── Storage (v3 + TTL 7gg) ────────────────────────── */
  var hasResumeSnapshot = false;

  function loadState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var saved = JSON.parse(raw);
      if (!saved || typeof saved !== 'object') return;
      if (typeof saved._ts !== 'number' || !isFinite(saved._ts)) {
        localStorage.removeItem(STORAGE_KEY);
        return;
      }
      var age = Date.now() - saved._ts;
      if (age > TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return;
      }
      // Defer applying the restore until user confirms (resume banner).
      hasResumeSnapshot = !!(saved.s && (
        saved.s.occasion || saved.s.level ||
        (saved.s.items && Object.keys(saved.s.items).length > 0)
      ));
    } catch (e) { console.warn('[saliha-gb] load failed:', e); }
  }

  function resumeFromSnapshot() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var saved = JSON.parse(raw);
      if (!saved || !saved.s) return false;
      var s = saved.s;
      if (typeof s.step === 'number') state.step = s.step;
      if (typeof s.occasion === 'string') state.occasion = s.occasion;
      if (typeof s.occasionOther === 'string') state.occasionOther = s.occasionOther;
      if (typeof s.level === 'string') state.level = s.level;
      if (s.items && typeof s.items === 'object') state.items = s.items;
      if (typeof s.activeCategory === 'string') state.activeCategory = s.activeCategory;
      if (typeof s.recipient === 'string') state.recipient = s.recipient;
      if (typeof s.message === 'string') state.message = s.message;
      if (typeof s.from === 'string') state.from = s.from;
      if (typeof s.boxMode === 'string') state.boxMode = s.boxMode;
      // Step rehydrate clamp
      var maxAllowedStep = 1;
      if (state.occasion) maxAllowedStep = 2;
      if (state.occasion && state.level) maxAllowedStep = 3;
      if (state.occasion && state.level && getItemCount() > 0) maxAllowedStep = 4;
      if (state.step > maxAllowedStep) state.step = maxAllowedStep;
      if (state.step < 1) state.step = 1;
      return true;
    } catch (e) {
      console.warn('[saliha-gb] resume failed:', e);
      return false;
    }
  }

  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ _ts: Date.now(), s: state }));
    } catch (e) { console.warn('[saliha-gb] save failed:', e); }
  }

  function clearStorage() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  /* ─── Computed ──────────────────────────────────────── */
  function getItemArray() {
    return Object.keys(state.items).map(function(k) {
      return Object.assign({ variantId: k }, state.items[k]);
    });
  }
  function getItemCount() {
    return getItemArray().reduce(function(s, i) { return s + (i.qty || 0); }, 0);
  }
  function getCustomItems() {
    return getItemArray().filter(function(i) { return !i.isAddon && !i.isBoxParent; });
  }
  function getAddonItems() {
    return getItemArray().filter(function(i) { return i.isAddon; });
  }
  function getBoxParentItem() {
    return getItemArray().filter(function(i) { return i.isBoxParent; })[0] || null;
  }
  function getItemTotal() {
    return getItemArray().reduce(function(s, i) { return s + (i.price || 0) * (i.qty || 0); }, 0);
  }
  function getPackagingSurcharge() {
    if (isCuratedMode()) return 0;
    var lvl = getCurrentLevel();
    return lvl && lvl.surcharge ? lvl.surcharge : 0;
  }
  function getBoxTotal() {
    return getItemTotal() + getPackagingSurcharge();
  }
  function getCurrentLevel() {
    if (!state.level) return null;
    for (var i = 0; i < LEVELS.length; i++) if (LEVELS[i].id === state.level) return LEVELS[i];
    return null;
  }
  function getCurrentOccasion() {
    if (!state.occasion) return null;
    for (var i = 0; i < OCCASIONS.length; i++) if (OCCASIONS[i].id === state.occasion) return OCCASIONS[i];
    return null;
  }
  function isMaxReached() {
    var lvl = getCurrentLevel();
    if (!lvl) return false;
    return getCustomItems().reduce(function(s, i) { return s + (i.qty || 0); }, 0) >= lvl.maxItems;
  }
  function isMinReached() {
    var lvl = getCurrentLevel();
    var custom = getCustomItems().reduce(function(s, i) { return s + (i.qty || 0); }, 0);
    if (!lvl) return custom > 0;
    return custom >= lvl.minItems;
  }
  function getCategoryProducts(catId) {
    return PRODUCTS.filter(function(p) { return p.cat === catId; });
  }
  function findProductById(id) {
    for (var i = 0; i < PRODUCTS.length; i++) {
      if (String(PRODUCTS[i].id) === String(id)) return PRODUCTS[i];
    }
    return null;
  }
  function findProductByHandle(h) {
    if (!h) return null;
    for (var i = 0; i < PRODUCTS.length; i++) {
      if (PRODUCTS[i].handle === h) return PRODUCTS[i];
    }
    return null;
  }
  function isCuratedMode() {
    return state.boxMode && state.boxMode.indexOf('curated:') === 0;
  }
  function getCuratedBox() {
    if (!isCuratedMode()) return null;
    var id = state.boxMode.split(':')[1];
    for (var i = 0; i < CURATED.length; i++) if (CURATED[i].id === id) return CURATED[i];
    return null;
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function formatPrice(p) {
    if (p == null) return '—';
    return '€' + parseFloat(p).toFixed(2).replace('.', ',');
  }
  /* Defense-in-depth: strip control chars / angle brackets before any
     value flows into cart line-item properties. Renderers downstream
     may not escape; this enforces a safe ceiling regardless. */
  function sanitizeCartProp(s, max) {
    if (s == null) return '';
    var rxCtrl = new RegExp('[\\x00-\\x1F]', 'g');
    var rxAngles = /[<>]/g;
    var rxWs = /[ \t]+/g;
    return String(s)
      .replace(rxCtrl, ' ')
      .replace(rxAngles, '')
      .replace(rxWs, ' ')
      .trim()
      .slice(0, max || 200);
  }

  /* ─── Step navigation ──────────────────────────────── */
  function canAdvanceTo(n) {
    if (n <= state.step) return true;
    if (n >= 2 && !state.occasion) return false;
    if (n >= 3 && (!state.occasion || !state.level)) return false;
    if (n >= 4 && getItemCount() === 0) return false;
    return true;
  }

  function setStep(n) {
    var target = canAdvanceTo(n) ? n : state.step;
    state.step = Math.max(1, Math.min(4, target));
    state.expandedProductId = null;
    saveState();
    renderAll();
    // Scroll alle SCELTE dello step attivo (step bar + pannello sotto), NON in cima al sito/hero.
    var anchor = document.querySelector('[data-gb-stepbar]') || document.querySelector('#gb-configurator') || document.querySelector('[data-gb-page]');
    if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ─── Renderers ─────────────────────────────────────── */
  function renderStepbar() {
    var btns = document.querySelectorAll('[data-gb-step-btn]');
    btns.forEach(function(btn) {
      var n = parseInt(btn.getAttribute('data-gb-step-btn'), 10);
      btn.setAttribute('data-active', n === state.step ? 'true' : 'false');
      btn.setAttribute('data-done', n < state.step ? 'true' : 'false');
      if (n === state.step) btn.setAttribute('aria-current', 'step');
      else btn.removeAttribute('aria-current');
    });
  }

  function renderPanels() {
    document.querySelectorAll('[data-gb-step]').forEach(function(p) {
      var n = parseInt(p.getAttribute('data-gb-step'), 10);
      p.setAttribute('data-active', n === state.step ? 'true' : 'false');
    });
  }

  function renderStep1() {
    var grid = document.querySelector('[data-gb-occasion-grid]');
    if (!grid) return;
    grid.innerHTML = OCCASIONS.map(function(o) {
      var active = state.occasion === o.id;
      return '<button type="button" class="gb-occasion-card" data-gb-occasion="' + escapeHtml(o.id) + '" data-active="' + (active ? 'true' : 'false') + '" aria-pressed="' + (active ? 'true' : 'false') + '">' +
             '<span class="gb-occasion-card__glyph" aria-hidden="true">' + escapeHtml(o.glyph) + '</span>' +
             '<span class="gb-occasion-card__label">' + escapeHtml(o.label) + '</span>' +
             (active ? '<span class="gb-occasion-card__check" aria-hidden="true">✓</span>' : '') +
             '</button>';
    }).join('');

    /* "Un pensiero" → testo libero */
    var otherWrap = document.querySelector('[data-gb-occasion-other-wrap]');
    var otherInput = document.querySelector('[data-gb-occasion-other]');
    var showOther = state.occasion === 'altro';
    if (otherWrap) {
      if (showOther) otherWrap.removeAttribute('hidden');
      else otherWrap.setAttribute('hidden', '');
    }
    if (otherInput && otherInput.value !== state.occasionOther) {
      otherInput.value = state.occasionOther || '';
    }

    var otherOk = state.occasion !== 'altro' || !!(state.occasionOther && state.occasionOther.trim());
    var nextBtn = document.querySelector('[data-gb-next="1"]');
    if (nextBtn) nextBtn.disabled = !(state.occasion && otherOk);
  }

  function renderStep2() {
    var grid = document.querySelector('[data-gb-level-grid]');
    if (!grid) return;
    grid.setAttribute('role', 'radiogroup');
    grid.setAttribute('aria-label', 'Tipo di confezione');
    grid.innerHTML = LEVELS.map(function(l) {
      var active = state.level === l.id;
      var isPremium = l.id === 'premium';
      var surchargeLabel = (l.surcharge != null) ? '+€' + l.surcharge : '';
      var badge = isPremium
        ? '<span class="gb-level-card__badge" aria-hidden="true">✦ Più scelta · scatola velvet</span>'
        : '';
      return '<button type="button" class="gb-level-card" data-gb-level="' + escapeHtml(l.id) + '" data-level-id="' + escapeHtml(l.id) + '" data-active="' + (active ? 'true' : 'false') + '" aria-pressed="' + (active ? 'true' : 'false') + '" role="radio" aria-checked="' + (active ? 'true' : 'false') + '">' +
             badge +
             '<span class="gb-level-card__glyph" aria-hidden="true">' + escapeHtml(l.glyph) + '</span>' +
             '<h3 class="gb-level-card__title">' + escapeHtml(l.label) + '</h3>' +
             '<p class="gb-level-card__items">' + escapeHtml(l.itemsLabel) + '</p>' +
             '<p class="gb-level-card__blurb">' + escapeHtml(l.blurb) + '</p>' +
             '<p class="gb-level-card__surcharge"><span class="gb-level-card__surcharge-label">Confezione</span> <span class="gb-level-card__surcharge-value">' + escapeHtml(surchargeLabel) + '</span></p>' +
             (active ? '<span class="gb-level-card__check" aria-hidden="true">✓</span>' : '') +
             '</button>';
    }).join('');

    var nextBtn = document.querySelector('[data-gb-next="2"]');
    if (nextBtn) nextBtn.disabled = !state.level;
  }

  function renderProductCard(p, opts) {
    opts = opts || {};
    var asAddon = !!opts.asAddon;
    var inBox = false;
    var qty = 0;
    Object.keys(state.items).forEach(function(vid) {
      var it = state.items[vid];
      if (String(it.productId) === String(p.id)) {
        var matchAddon = (asAddon && it.isAddon) || (!asAddon && !it.isAddon && !it.isBoxParent);
        if (matchAddon) { inBox = true; qty += it.qty || 0; }
      }
    });

    var maxed = !asAddon && isMaxReached() && !inBox;
    var unavailable = !p.available;
    var hasMultiVariant = p.variants && p.variants.filter(function(v) { return v.available; }).length > 1
                          && p.variants.some(function(v) { return v.title && v.title !== 'Default Title'; });
    var isExpanded = state.expandedProductId === String(p.id);
    var disabled = (maxed && !isExpanded) || unavailable;

    var img = p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy" class="gb-product-card__img">'
                      : '<div class="gb-product-card__placeholder" aria-hidden="true">✦</div>';

    var dataKey = asAddon ? 'data-gb-add-addon' : 'data-gb-add';
    var rmDataKey = asAddon ? 'data-gb-remove-addon' : 'data-gb-remove';

    var actionBtn;
    if (inBox) {
      actionBtn = '<button type="button" class="gb-product-card__remove" ' + rmDataKey + '="' + p.id + '" aria-label="Rimuovi ' + escapeHtml(p.name) + ' dalla box">✕ Rimuovi</button>';
    } else if (hasMultiVariant && !unavailable) {
      actionBtn = '<button type="button" class="gb-product-card__add" data-gb-expand="' + p.id + '" aria-expanded="' + (isExpanded ? 'true' : 'false') + '"' + (disabled ? ' disabled' : '') + '>' +
                  (isExpanded ? '✕ Chiudi' : '+ Scegli') +
                  '</button>';
    } else {
      actionBtn = '<button type="button" class="gb-product-card__add" ' + dataKey + '="' + p.id + '"' + (disabled ? ' disabled' : '') + '>' +
                  (unavailable ? 'Esaurito' : '+ Aggiungi') +
                  '</button>';
    }

    var expansion = '';
    if (isExpanded && !unavailable) {
      expansion = renderVariantExpansion(p, asAddon);
    }

    return '<article class="gb-product-card" data-in-box="' + (inBox ? 'true' : 'false') + '" data-unavailable="' + (unavailable ? 'true' : 'false') + '" data-expanded="' + (isExpanded ? 'true' : 'false') + '">' +
           '<div class="gb-product-card__media">' + img +
             (inBox ? '<span class="gb-product-card__badge">×' + qty + '</span>' : '') +
             (unavailable ? '<span class="gb-product-card__sold">Esaurito</span>' : '') +
           '</div>' +
           '<div class="gb-product-card__body">' +
             '<h4 class="gb-product-card__name">' + escapeHtml(p.name || '') + '</h4>' +
             '<div class="gb-product-card__row">' +
               '<span class="gb-product-card__price">' + escapeHtml(p.priceFormatted || formatPrice(p.price)) + '</span>' +
               actionBtn +
             '</div>' +
             expansion +
           '</div>' +
           '</article>';
  }

  function renderVariantExpansion(p, asAddon) {
    var variants = p.variants || [];
    // Group variants by option dimension (best-effort: if titles contain "/", split into two groups)
    var hasSlash = variants.some(function(v) { return v.title && v.title.indexOf('/') !== -1; });
    var groups;
    if (hasSlash) {
      // Build two-dimensional grid (e.g., "Colore / Taglia")
      var dim1 = {};
      var dim2 = {};
      variants.forEach(function(v) {
        if (!v.title) return;
        var parts = v.title.split(' / ').map(function(s) { return s.trim(); });
        if (parts[0]) dim1[parts[0]] = true;
        if (parts[1]) dim2[parts[1]] = true;
      });
      groups = [
        { label: 'Scegli opzione 1', values: Object.keys(dim1) },
        { label: 'Scegli opzione 2', values: Object.keys(dim2) }
      ];
      // Render two chip rows + final variant button after both picked
      var pid = String(p.id);
      var sel1 = window.__SALIHA_GB_VARIANT_SEL__ && window.__SALIHA_GB_VARIANT_SEL__[pid] ? window.__SALIHA_GB_VARIANT_SEL__[pid].sel1 : null;
      var sel2 = window.__SALIHA_GB_VARIANT_SEL__ && window.__SALIHA_GB_VARIANT_SEL__[pid] ? window.__SALIHA_GB_VARIANT_SEL__[pid].sel2 : null;

      var html = '<div class="gb-variant-expansion" role="group" aria-label="Opzioni di ' + escapeHtml(p.name) + '">';
      groups.forEach(function(g, gi) {
        html += '<p class="gb-variant-expansion__label">' + escapeHtml(g.label) + '</p>';
        html += '<div class="gb-variant-chips" role="radiogroup">';
        g.values.forEach(function(val) {
          // Check availability: any variant matching this dim value at this slot
          var available = variants.some(function(v) {
            if (!v.title) return false;
            var parts = v.title.split(' / ').map(function(s) { return s.trim(); });
            return parts[gi] === val && v.available;
          });
          var selected = (gi === 0 ? sel1 : sel2) === val;
          html += '<button type="button" class="gb-variant-chip" data-gb-vchip="' + escapeHtml(pid) + '" data-gb-vdim="' + gi + '" data-gb-vval="' + escapeHtml(val) + '"' +
                  (!available ? ' disabled aria-disabled="true" title="Esaurito"' : '') +
                  ' aria-checked="' + (selected ? 'true' : 'false') + '" role="radio"' +
                  ' data-selected="' + (selected ? 'true' : 'false') + '">' +
                  escapeHtml(val) +
                  (!available ? ' <span class="gb-variant-chip__oos">esaurito</span>' : '') +
                  '</button>';
        });
        html += '</div>';
      });
      // Build "Aggiungi" CTA only when both dimensions picked
      var match = null;
      if (sel1 && sel2) {
        variants.forEach(function(v) {
          if (!v.title) return;
          var parts = v.title.split(' / ').map(function(s) { return s.trim(); });
          if (parts[0] === sel1 && parts[1] === sel2 && v.available) match = v;
        });
      }
      var addKey = asAddon ? 'data-gb-add-variant-addon' : 'data-gb-add-variant';
      if (match) {
        var matchPrice = (match.price != null ? match.price : p.price);
        html += '<button type="button" class="gb-variant-confirm" ' + addKey + '="' + match.id + '" data-gb-vproduct="' + escapeHtml(pid) + '">' +
                '+ Aggiungi alla box · ' + formatPrice(matchPrice) +
                '</button>';
      } else {
        html += '<button type="button" class="gb-variant-confirm" disabled>Seleziona entrambe le opzioni</button>';
      }
      html += '</div>';
      return html;
    }
    // Single dimension: simple chip row
    var titles = variants.filter(function(v) { return v.title && v.title !== 'Default Title'; }).map(function(v) { return v.title; });
    var labelDim = inferOptionLabel(titles);
    var html2 = '<div class="gb-variant-expansion" role="group" aria-label="Opzioni di ' + escapeHtml(p.name) + '">';
    html2 += '<p class="gb-variant-expansion__label">' + escapeHtml(labelDim) + '</p>';
    html2 += '<div class="gb-variant-chips">';
    variants.forEach(function(v) {
      if (!v.title || v.title === 'Default Title') return;
      var addKey = asAddon ? 'data-gb-add-variant-addon' : 'data-gb-add-variant';
      var vp = (v.price != null ? v.price : p.price);
      // Immediate-commit single-dim chips: role=button (not radio) so screen
      // readers don't promise a persistent radiogroup state.
      html2 += '<button type="button" class="gb-variant-chip" ' + addKey + '="' + v.id + '" data-gb-vproduct="' + escapeHtml(String(p.id)) + '"' +
               (!v.available ? ' disabled aria-disabled="true"' : '') + '>' +
               escapeHtml(v.title) +
               '<span class="gb-variant-chip__price">' + formatPrice(vp) + '</span>' +
               (!v.available ? '<span class="gb-variant-chip__oos">esaurito</span>' : '') +
               '</button>';
    });
    html2 += '</div></div>';
    return html2;
  }

  function inferOptionLabel(titles) {
    // Naive heuristic: detect if titles look like sizes vs colors
    var sizeRx = /^(XX?S|S|M|L|XX?L|XXXL|One ?Size|Taglia)/i;
    var anySize = titles.some(function(t) { return sizeRx.test(t); });
    if (anySize) return 'Scegli la taglia';
    return 'Scegli la variante';
  }

  /* Prodotti consigliati per l'occasione corrente: risolve gli handle del
     preset, filtra a disponibili, dedup, mantiene l'ordine del preset.
     Occasione 'altro' o senza preset → array vuoto (nessuna fascia). */
  function getRecommendedProducts() {
    if (!state.occasion || state.occasion === 'altro') return [];
    var handles = PRESETS[state.occasion];
    if (!handles || !handles.length) return [];
    var seen = {};
    var out = [];
    for (var i = 0; i < handles.length; i++) {
      var h = handles[i];
      if (seen[h]) continue;
      seen[h] = true;
      var p = findProductByHandle(h);
      if (p && p.available) out.push(p);
    }
    return out;
  }

  function renderReco() {
    /* Fascia 'Consigliati per occasione' RIMOSSA (decisione utente 2026-08-13):
       duplicava gli stessi prodotti delle tab categorie sottostanti creando
       confusione allo step Prodotti. PRESETS/getRecommendedProducts restano
       per un eventuale riuso (es. badge sulla card) — qui solo spegnimento. */
    var recoEl = document.querySelector('[data-gb-reco]');
    if (recoEl) {
      recoEl.setAttribute('hidden', '');
      recoEl.innerHTML = '';
    }
  }

  function renderStep3() {
    renderReco();
    var tabsEl = document.querySelector('[data-gb-cat-tabs]');
    var panelsEl = document.querySelector('[data-gb-cat-panels]');
    var warnEl = document.querySelector('[data-gb-max-warning]');
    if (!tabsEl || !panelsEl) return;

    if (!state.activeCategory && CATEGORIES.length > 0) {
      state.activeCategory = CATEGORIES[0].id;
    }

    tabsEl.innerHTML = CATEGORIES.map(function(c) {
      var count = getCategoryProducts(c.id).length;
      if (count === 0) return '';
      var active = state.activeCategory === c.id;
      return '<button type="button" class="gb-cat-tab" data-gb-cat="' + escapeHtml(c.id) + '" data-active="' + (active ? 'true' : 'false') + '" role="tab" aria-selected="' + (active ? 'true' : 'false') + '">' +
             escapeHtml(c.label) + ' <span class="gb-cat-tab__count">' + count + '</span>' +
             '</button>';
    }).join('');

    var prods = getCategoryProducts(state.activeCategory);
    panelsEl.innerHTML = '<div class="gb-product-grid">' +
      prods.map(function(p) { return renderProductCard(p, { asAddon: false }); }).join('') +
      '</div>';

    if (warnEl) {
      warnEl.setAttribute('data-visible', isMaxReached() ? 'true' : 'false');
    }

    var nextBtn = document.querySelector('[data-gb-next="3"]');
    if (nextBtn) nextBtn.disabled = !isMinReached();
  }

  function renderStep5() {
    /* Sync biglietto inputs ↔ state */
    var nameEl = document.querySelector('[data-gb-name]');
    var msgEl = document.querySelector('[data-gb-message]');
    var fromEl = document.querySelector('[data-gb-from]');
    if (nameEl && nameEl.value !== state.recipient) nameEl.value = state.recipient || '';
    if (msgEl && msgEl.value !== state.message) msgEl.value = state.message || '';
    if (fromEl && fromEl.value !== state.from) fromEl.value = state.from || '';

    /* Live card preview */
    var toEl = document.querySelector('[data-gb-card-to]');
    var msgPreviewEl = document.querySelector('[data-gb-card-msg]');
    var fromPreviewEl = document.querySelector('[data-gb-card-from]');
    if (toEl) {
      toEl.innerHTML = state.recipient && state.recipient.trim()
        ? '<span>Per ' + escapeHtml(state.recipient.trim()) + '</span>'
        : '<span class="gb-card-preview__to-placeholder">Nome destinatario...</span>';
    }
    if (msgPreviewEl) {
      msgPreviewEl.textContent = state.message && state.message.trim() ? state.message : 'Il tuo messaggio apparirà qui...';
      msgPreviewEl.style.fontStyle = (state.message && state.message.trim()) ? 'normal' : 'italic';
      msgPreviewEl.style.color = (state.message && state.message.trim()) ? '' : 'var(--gb-mute)';
    }
    if (fromPreviewEl) {
      fromPreviewEl.textContent = state.from && state.from.trim() ? '— ' + state.from.trim() : '';
    }

    var chipsEl = document.querySelector('[data-gb-summary-chips]');
    var prodsEl = document.querySelector('[data-gb-summary-products]');
    var priceEl = document.querySelector('[data-gb-summary-price]');

    var occ = getCurrentOccasion();
    var lvl = getCurrentLevel();
    var box = getCuratedBox();

    if (chipsEl) {
      var chips = [];
      if (box) chips.push('<span class="gb-chip gb-chip--curated"><span class="gb-chip__glyph">' + escapeHtml(box.glyph || '✦') + '</span> ' + escapeHtml(box.title) + '</span>');
      if (occ && !box) chips.push('<span class="gb-chip"><span class="gb-chip__glyph">' + escapeHtml(occ.glyph) + '</span> ' + escapeHtml(occ.label) + '</span>');
      if (lvl && !box) chips.push('<span class="gb-chip"><span class="gb-chip__glyph">' + escapeHtml(lvl.glyph) + '</span> ' + escapeHtml(lvl.label) + '</span>');
      chipsEl.innerHTML = chips.join('');
    }

    if (prodsEl) {
      var arr = getItemArray();
      // For curated mode: list box contents (full) + addon items separately
      if (box) {
        var parts = [];
        parts.push('<p class="gb-summary__section-label">Contenuto curato della box</p>');
        parts.push('<ul class="gb-summary__curated-list">' +
          (box.contents || []).map(function(c) {
            return '<li>' + escapeHtml(c.label) + (c.qty && c.qty > 1 ? ' <span>×' + c.qty + '</span>' : '') + '</li>';
          }).join('') +
          '</ul>');
        var addons = getAddonItems();
        if (addons.length > 0) {
          parts.push('<p class="gb-summary__section-label gb-summary__section-label--addons">Aggiunto da te</p>');
          parts.push(addons.map(function(it) {
            var imgHtml = it.image ? '<img src="' + escapeHtml(it.image) + '" alt="" class="gb-summary__product-img">' : '<div class="gb-summary__product-ph">✦</div>';
            return '<div class="gb-summary__product">' + imgHtml +
                   '<div class="gb-summary__product-info">' +
                     '<span class="gb-summary__product-name">' + escapeHtml(it.name || '') + '</span>' +
                     (it.variantTitle && it.variantTitle !== 'Default Title' ? '<span class="gb-summary__product-variant">' + escapeHtml(it.variantTitle) + '</span>' : '') +
                   '</div>' +
                   '<span class="gb-summary__product-qty">×' + (it.qty || 1) + '</span>' +
                   '<span class="gb-summary__product-price">' + formatPrice((it.price || 0) * (it.qty || 1)) + '</span>' +
                   '</div>';
          }).join(''));
        }
        prodsEl.innerHTML = parts.join('');
      } else if (arr.length === 0) {
        prodsEl.innerHTML = '<p class="gb-summary__empty">Nessun prodotto nella box.</p>';
      } else {
        prodsEl.innerHTML = arr.map(function(it) {
          var imgHtml = it.image ? '<img src="' + escapeHtml(it.image) + '" alt="" class="gb-summary__product-img">' : '<div class="gb-summary__product-ph">✦</div>';
          return '<div class="gb-summary__product">' + imgHtml +
                 '<div class="gb-summary__product-info">' +
                   '<span class="gb-summary__product-name">' + escapeHtml(it.name || '') + '</span>' +
                   (it.variantTitle && it.variantTitle !== 'Default Title' ? '<span class="gb-summary__product-variant">' + escapeHtml(it.variantTitle) + '</span>' : '') +
                 '</div>' +
                 '<span class="gb-summary__product-qty">×' + (it.qty || 1) + '</span>' +
                 '<span class="gb-summary__product-price">' + formatPrice((it.price || 0) * (it.qty || 1)) + '</span>' +
                 '</div>';
        }).join('');
      }
    }


    /* Price breakdown: prodotti + confezione + totale */
    var breakdownEl = document.querySelector('[data-gb-price-breakdown]');
    if (breakdownEl) {
      var surcharge = getPackagingSurcharge();
      var lines = [];
      lines.push('<div class="gb-price-line"><span>Prodotti</span><span>' + formatPrice(getItemTotal()) + '</span></div>');
      if (surcharge > 0 && lvl) {
        lines.push('<div class="gb-price-line"><span>Confezione · ' + escapeHtml(lvl.label) + '</span><span>' + formatPrice(surcharge) + '</span></div>');
      }
      lines.push('<div class="gb-price-line gb-price-line--total"><span>Totale</span><span>' + formatPrice(getBoxTotal()) + '</span></div>');
      breakdownEl.innerHTML = lines.join('');
    }

    if (priceEl) priceEl.textContent = formatPrice(getBoxTotal());

    /* Messaggio obbligatorio → gate dei bottoni "Aggiungi al carrello".
       Eccezione sidebar (visibile solo allo step Prodotti): lì l'azione
       giusta con prodotti in box è "Vai al riepilogo" (dove si scrive il
       biglietto), non un ATC disabilitato senza spiegazione. */
    var msgOk = !!(state.message && state.message.trim());
    var gateCount = getItemCount();
    document.querySelectorAll('[data-gb-cart-btn]').forEach(function(btn) {
      if (btn.getAttribute('data-loading')) return;
      if (btn.closest('[data-gb-sidebar]')) {
        if (gateCount > 0) {
          btn.disabled = false;
          btn.setAttribute('data-mode', 'summary');
          btn.innerHTML = 'Vai al riepilogo&nbsp;&nbsp;<span aria-hidden="true">→</span>';
        } else {
          btn.disabled = true;
          btn.setAttribute('data-mode', 'cart');
          btn.innerHTML = '✦ &nbsp; Aggiungi al carrello';
        }
        return;
      }
      btn.disabled = !msgOk;
    });
    var msgGate = document.querySelector('[data-gb-message-gate]');
    if (msgGate) {
      if (msgOk) msgGate.setAttribute('hidden', '');
      else msgGate.removeAttribute('hidden');
    }
  }

  function renderSidebar() {
    var preview = document.querySelector('[data-gb-preview]');
    if (!preview) return;
    var countEl = preview.querySelector('[data-gb-preview-count]');
    var occEl = preview.querySelector('[data-gb-preview-occasion]');
    var prodsEl = preview.querySelector('[data-gb-preview-products]');
    var priceWrap = preview.querySelector('[data-gb-preview-price-wrap]');

    var count = getItemCount();
    var occ = getCurrentOccasion();
    var lvl = getCurrentLevel();
    var box = getCuratedBox();

    if (countEl) countEl.textContent = count + ' ' + (count === 1 ? 'prodotto' : 'prodotti');
    if (occEl) {
      if (box) occEl.textContent = (box.glyph || '✦') + '  ' + box.title;
      else if (occ && lvl) occEl.textContent = occ.glyph + '  ' + occ.label + ' · ' + lvl.label;
      else if (occ) occEl.textContent = occ.glyph + '  ' + occ.label;
      else occEl.textContent = 'Scegli un\'occasione →';
    }
    if (prodsEl) {
      var arr = getItemArray();
      if (arr.length === 0) {
        prodsEl.innerHTML = '<p class="gb-preview-empty">La tua box è vuota — ' +
          (state.step >= 3 ? 'scegli i prodotti' : 'continua i passaggi') + '</p>';
      } else {
        prodsEl.innerHTML = arr.map(function(it) {
          return '<div class="gb-preview-item">' +
                 '<span class="gb-preview-item__name">' + escapeHtml(it.name || '') + '</span>' +
                 (it.qty > 1 ? '<span class="gb-preview-item__qty">×' + it.qty + '</span>' : '') +
                 '</div>';
        }).join('');
      }
    }
    /* Prezzo scomposto: Prodotti · Confezione · Totale (mini-tabella).
       Quando non ci sono ancora prodotti, resta la fascia di prezzo. */
    if (priceWrap) {
      var itemsTotal = getItemTotal();
      var surcharge = getPackagingSurcharge();
      if (itemsTotal > 0) {
        var rows = '';
        rows += '<div class="gb-preview-breakdown__line"><span>Prodotti</span><span>' + formatPrice(itemsTotal) + '</span></div>';
        if (surcharge > 0) {
          rows += '<div class="gb-preview-breakdown__line"><span>Confezione</span><span>' + formatPrice(surcharge) + '</span></div>';
        }
        rows += '<div class="gb-preview-breakdown__line gb-preview-breakdown__line--total"><span>Totale</span><span>' + formatPrice(getBoxTotal()) + '</span></div>';
        priceWrap.classList.add('gb-preview-price--breakdown');
        priceWrap.innerHTML = '<div class="gb-preview-breakdown">' + rows + '</div>';
      } else {
        priceWrap.classList.remove('gb-preview-price--breakdown');
        priceWrap.innerHTML =
          '<span class="gb-preview-price__label">Fascia di prezzo</span>' +
          '<span class="gb-preview-price__value" data-gb-preview-price>' + (lvl ? escapeHtml(lvl.priceRange) : '—') + '</span>';
      }
    }
  }

  function renderMobileStrip() {
    var strip = document.querySelector('[data-gb-mobile-strip]');
    if (!strip) return;
    var countEl = strip.querySelector('[data-gb-strip-count]');
    var totalEl = strip.querySelector('[data-gb-strip-total]');
    var noteEl = strip.querySelector('[data-gb-strip-note]');
    var ctaEl = strip.querySelector('[data-gb-strip-cta]');

    var count = getItemCount();
    var total = getBoxTotal();
    var surcharge = getPackagingSurcharge();
    var occ = getCurrentOccasion();
    var box = getCuratedBox();
    var addonCount = getAddonItems().reduce(function(s, i) { return s + (i.qty || 0); }, 0);

    if (countEl) {
      if (box) {
        countEl.textContent = box.title + (addonCount > 0 ? ' · +' + addonCount + ' ' + (addonCount === 1 ? 'aggiunta' : 'aggiunte') : '');
      } else if (count === 0) {
        countEl.textContent = occ ? occ.label + ' · scegli prodotti' : 'Nessun prodotto';
      } else {
        countEl.textContent = count + ' ' + (count === 1 ? 'prodotto' : 'prodotti');
      }
    }
    if (totalEl) {
      totalEl.textContent = total > 0 ? formatPrice(total) : '';
      totalEl.setAttribute('data-visible', total > 0 ? 'true' : 'false');
    }
    if (noteEl) {
      if (total > 0 && surcharge > 0) noteEl.removeAttribute('hidden');
      else noteEl.setAttribute('hidden', '');
    }
    renderMobileSheet();
    if (ctaEl) {
      if (state.step >= 4 && count > 0) {
        ctaEl.textContent = '✦  Aggiungi al carrello';
        ctaEl.setAttribute('data-mode', 'cart');
        ctaEl.disabled = !(state.message && state.message.trim());
      } else if (count > 0) {
        ctaEl.textContent = 'Riepilogo →';
        ctaEl.setAttribute('data-mode', 'summary');
        ctaEl.disabled = false;
      } else {
        ctaEl.textContent = 'Continua →';
        ctaEl.setAttribute('data-mode', 'continue');
        ctaEl.disabled = false;
      }
    }
  }

  /* ─── Mobile bottom-sheet (lista prodotti + prezzo scomposto) ── */
  var __sheetOpen = false;

  function renderMobileSheet() {
    var sheet = document.querySelector('[data-gb-sheet]');
    if (!sheet) return;
    var titleEl = sheet.querySelector('[data-gb-sheet-title]');
    var prodsEl = sheet.querySelector('[data-gb-sheet-products]');
    var priceEl = sheet.querySelector('[data-gb-sheet-price]');

    var box = getCuratedBox();
    var occ = getCurrentOccasion();
    var lvl = getCurrentLevel();

    if (titleEl) {
      if (box) titleEl.textContent = box.title;
      else if (occ && lvl) titleEl.textContent = occ.label + ' · ' + lvl.label;
      else if (occ) titleEl.textContent = occ.label;
      else titleEl.textContent = 'La tua Box';
    }

    if (prodsEl) {
      if (box) {
        var partsHtml = [];
        partsHtml.push('<ul class="gb-mobile-sheet__curated">' +
          (box.contents || []).map(function(c) {
            return '<li>' + escapeHtml(c.label) + (c.qty && c.qty > 1 ? ' <span>×' + c.qty + '</span>' : '') + '</li>';
          }).join('') +
          '</ul>');
        var addons = getAddonItems();
        if (addons.length > 0) {
          partsHtml.push(addons.map(function(it) {
            return '<div class="gb-mobile-sheet__item">' +
                   '<span class="gb-mobile-sheet__item-name">' + escapeHtml(it.name || '') +
                   (it.variantTitle && it.variantTitle !== 'Default Title' ? ' · ' + escapeHtml(it.variantTitle) : '') + '</span>' +
                   '<span class="gb-mobile-sheet__item-qty">×' + (it.qty || 1) + '</span>' +
                   '<span class="gb-mobile-sheet__item-price">' + formatPrice((it.price || 0) * (it.qty || 1)) + '</span>' +
                   '</div>';
          }).join(''));
        }
        prodsEl.innerHTML = partsHtml.join('');
      } else {
        var arr = getItemArray();
        if (arr.length === 0) {
          prodsEl.innerHTML = '<p class="gb-preview-empty">La tua box è vuota — scegli i prodotti</p>';
        } else {
          prodsEl.innerHTML = arr.map(function(it) {
            return '<div class="gb-mobile-sheet__item">' +
                   '<span class="gb-mobile-sheet__item-name">' + escapeHtml(it.name || '') +
                   (it.variantTitle && it.variantTitle !== 'Default Title' ? ' · ' + escapeHtml(it.variantTitle) : '') + '</span>' +
                   '<span class="gb-mobile-sheet__item-qty">×' + (it.qty || 1) + '</span>' +
                   '<span class="gb-mobile-sheet__item-price">' + formatPrice((it.price || 0) * (it.qty || 1)) + '</span>' +
                   '<button type="button" class="gb-mobile-sheet__item-remove" data-gb-remove="' + escapeHtml(String(it.productId)) + '" aria-label="Rimuovi ' + escapeHtml(it.name || 'prodotto') + ' dalla box">✕</button>' +
                   '</div>';
          }).join('');
        }
      }
    }

    if (priceEl) {
      var itemsTotal = getItemTotal();
      var surcharge = getPackagingSurcharge();
      if (itemsTotal > 0) {
        var rows = '';
        rows += '<div class="gb-mobile-sheet__price-line"><span>Prodotti</span><span>' + formatPrice(itemsTotal) + '</span></div>';
        if (surcharge > 0) {
          rows += '<div class="gb-mobile-sheet__price-line"><span>Confezione</span><span>' + formatPrice(surcharge) + '</span></div>';
        }
        rows += '<div class="gb-mobile-sheet__price-line gb-mobile-sheet__price-line--total"><span>Totale</span><span>' + formatPrice(getBoxTotal()) + '</span></div>';
        priceEl.innerHTML = rows;
      } else {
        priceEl.innerHTML = '<div class="gb-mobile-sheet__price-line gb-mobile-sheet__price-line--total"><span>Totale</span><span>' + (lvl ? escapeHtml(lvl.priceRange) : '—') + '</span></div>';
      }
    }

    var summaryBtn = sheet.querySelector('[data-gb-sheet-summary]');
    if (summaryBtn) {
      if (getItemCount() > 0 && state.step < 4) summaryBtn.removeAttribute('hidden');
      else summaryBtn.setAttribute('hidden', '');
    }
  }

  function setSheetState(open) {
    var sheet = document.querySelector('[data-gb-sheet]');
    var backdrop = document.querySelector('[data-gb-sheet-backdrop]');
    var strip = document.querySelector('[data-gb-mobile-strip]');
    if (!sheet) return;
    __sheetOpen = !!open;
    if (strip) strip.style.display = open ? 'none' : '';
    if (open) {
      renderMobileSheet();
      sheet.removeAttribute('hidden');
      sheet.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.removeAttribute('hidden');
      // Defer the open state to the next frame so the slide-up transition plays
      // (the element must first paint at translateY(100%) before animating to 0).
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          if (!__sheetOpen) return;
          sheet.setAttribute('data-open', 'true');
          if (backdrop) backdrop.setAttribute('data-open', 'true');
        });
      });
    } else {
      sheet.setAttribute('data-open', 'false');
      sheet.setAttribute('aria-hidden', 'true');
      // Defer hidden so the close transition can play
      window.setTimeout(function() {
        if (!__sheetOpen) { sheet.setAttribute('hidden', ''); }
      }, 260);
      if (backdrop) {
        backdrop.setAttribute('data-open', 'false');
        window.setTimeout(function() { if (!__sheetOpen) backdrop.setAttribute('hidden', ''); }, 260);
      }
    }
    document.querySelectorAll('[data-gb-sheet-toggle][aria-controls]').forEach(function(btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    var chev = document.querySelector('[data-gb-strip-chev]');
    if (chev) chev.setAttribute('data-open', open ? 'true' : 'false');
  }

  function toggleMobileSheet() {
    setSheetState(!__sheetOpen);
  }

  function closeMobileSheet() {
    if (__sheetOpen) setSheetState(false);
  }

  function renderReadyGrid() {
    var grid = document.querySelector('[data-gb-ready-grid]');
    if (!grid) return;
    grid.innerHTML = CURATED.map(function(c) {
      var blocked = !!c.blocked;
      var unavailable = !c.available;
      var contentsCount = c.contents ? c.contents.length : 0;
      var imgHtml = c.image
        ? '<img src="' + escapeHtml(c.image) + '" alt="" class="gb-ready-card__img" loading="lazy">'
        : '<div class="gb-ready-card__top"><span class="gb-ready-card__glyph">' + escapeHtml(c.glyph || '✦') + '</span></div>';
      var badge = blocked
        ? '<span class="gb-ready-card__badge gb-ready-card__badge--blocked">Tornano presto</span>'
        : (c.compareAtPrice ? '<span class="gb-ready-card__badge">−' + Math.round(100 - (c.price * 100 / c.compareAtPrice)) + '%</span>' : '');

      var clickAttr = blocked
        ? 'data-gb-notify="' + escapeHtml(c.id) + '"'
        : 'data-gb-ready-click="' + escapeHtml(c.id) + '"';

      var scarcityHtml = (blocked && c.scarcityNote)
        ? '<p class="gb-ready-card__scarcity">✦ ' + escapeHtml(c.scarcityNote) + '</p>'
        : '';
      var blockedCta = blocked
        ? '<span class="gb-ready-card__notify-cta">Avvisami quando torna →</span>'
        : '';

      var tierHtml = c.tierName
        ? '<p class="gb-ready-card__tier"><span class="gb-ready-card__tier-name">' + escapeHtml(c.tierName) + '</span>' + (c.tierSubtitle ? ' · <em>' + escapeHtml(c.tierSubtitle) + '</em>' : '') + '</p>'
        : '';
      return '<button type="button" class="gb-ready-card" data-blocked="' + (blocked ? 'true' : 'false') + '" data-unavailable="' + (unavailable ? 'true' : 'false') + '" ' + clickAttr + ' aria-label="' + escapeHtml(c.title) + (blocked ? ' — Avvisami quando torna' : '') + '">' +
             imgHtml +
             badge +
             '<div class="gb-ready-card__body">' +
               tierHtml +
               '<h3 class="gb-ready-card__title">' + escapeHtml(c.title || '') + '</h3>' +
               '<p class="gb-ready-card__blurb">' + escapeHtml(c.blurb || '') + '</p>' +
               scarcityHtml +
               (contentsCount > 0 ? '<p class="gb-ready-card__contents">' + contentsCount + ' pezzi curati</p>' : '') +
               '<p class="gb-ready-card__price">' +
                 (c.compareAtPrice ? '<span class="gb-ready-card__compare">' + formatPrice(c.compareAtPrice) + '</span> ' : '') +
                 formatPrice(c.price) +
               '</p>' +
               (c.price >= 50 && !blocked ? '<p class="gb-ready-card__scalapay">3 rate da ' + formatPrice(c.price / 3) + ' · Scalapay</p>' : '') +
               blockedCta +
             '</div>' +
             '</button>';
    }).join('');
  }

  function renderFaq() {
    var list = document.querySelector('[data-gb-faq-list]');
    if (!list) return;
    // If static fallback FAQ markup is already present (SSR), don't overwrite.
    // The static FAQ is SEO-indexable and works without JS — only fill if empty.
    if (list.querySelector('.gb-faq-item, .gb-faq__item')) return;
    list.innerHTML = FAQS.map(function(f) {
      return '<details class="gb-faq__item">' +
             '<summary class="gb-faq__q">' + escapeHtml(f.q) + '</summary>' +
             '<p class="gb-faq__a">' + escapeHtml(f.a) + '</p>' +
             '</details>';
    }).join('');
  }

  function renderResumeBanner() {
    var banner = document.querySelector('[data-gb-resume-banner]');
    if (!banner) return;
    if (hasResumeSnapshot) {
      banner.removeAttribute('hidden');
    } else {
      banner.setAttribute('hidden', '');
    }
  }

  function renderAll() {
    var pg = document.querySelector('[data-gb-page]');
    if (pg) pg.setAttribute('data-gb-current-step', String(state.step));
    renderStepbar();
    renderPanels();
    renderStep1();
    renderStep2();
    renderStep3();
    renderStep5();
    renderSidebar();
    renderMobileStrip();
    renderReadyGrid();
    renderFaq();
    renderResumeBanner();
  }

  /* ─── Product add/remove ───────────────────────────── */
  function addProductVariant(variantId, opts) {
    opts = opts || {};
    var asAddon = !!opts.asAddon;
    var product = null, variant = null;
    for (var i = 0; i < PRODUCTS.length; i++) {
      var p = PRODUCTS[i];
      for (var j = 0; j < (p.variants || []).length; j++) {
        if (String(p.variants[j].id) === String(variantId)) {
          product = p; variant = p.variants[j]; break;
        }
      }
      if (variant) break;
    }
    if (!product || !variant || !variant.available) {
      showCartError('Variante non disponibile.');
      return;
    }
    if (!asAddon && isMaxReached()) return;

    var vid = String(variant.id);
    if (state.items[vid]) {
      state.items[vid].qty = (state.items[vid].qty || 0) + 1;
      // Preserve existing flags
    } else {
      state.items[vid] = {
        qty: 1,
        productId: product.id,
        productHandle: product.handle,
        name: product.name,
        price: variant.price || product.price,
        image: product.image,
        variantTitle: variant.title,
        isAddon: asAddon,
        isBoxParent: false
      };
    }
    state.expandedProductId = null;
    saveState();
    if (window.__SALIHA_GB_VARIANT_SEL__) {
      delete window.__SALIHA_GB_VARIANT_SEL__[String(product.id)];
    }
    renderStep3();
    renderStep5();
    renderSidebar();
    renderMobileStrip();
    trackEvent('giftbox_item_added', { variant: variant.title, product: product.handle, isAddon: asAddon });
  }

  function addProduct(productId, opts) {
    opts = opts || {};
    var p = findProductById(productId);
    if (!p || !p.available) return;
    var available = (p.variants || []).filter(function(v) { return v.available; });
    if (available.length === 0) {
      showCartError('"' + (p.name || 'Prodotto') + '" non è momentaneamente disponibile.');
      return;
    }
    // Single available variant or all default-title → add directly
    var hasReal = available.length > 1 && available.some(function(v) { return v.title && v.title !== 'Default Title'; });
    if (!hasReal) {
      addProductVariant(available[0].id, opts);
      return;
    }
    // Multi-variant: open expansion card (state.expandedProductId)
    state.expandedProductId = String(p.id);
    saveState();
    renderStep3();
  }

  function removeProduct(productId, opts) {
    opts = opts || {};
    var asAddon = !!opts.asAddon;
    Object.keys(state.items).forEach(function(vid) {
      var it = state.items[vid];
      if (String(it.productId) === String(productId)) {
        if ((asAddon && it.isAddon) || (!asAddon && !it.isAddon && !it.isBoxParent)) {
          delete state.items[vid];
        }
      }
    });
    saveState();
    renderStep3();
    renderStep5();
    renderSidebar();
    renderMobileStrip();
  }

  function toggleVariantChip(productId, dim, value) {
    if (!window.__SALIHA_GB_VARIANT_SEL__) window.__SALIHA_GB_VARIANT_SEL__ = {};
    if (!window.__SALIHA_GB_VARIANT_SEL__[productId]) window.__SALIHA_GB_VARIANT_SEL__[productId] = {};
    var key = dim === 0 ? 'sel1' : 'sel2';
    window.__SALIHA_GB_VARIANT_SEL__[productId][key] = value;
    renderStep3();
  }

  /* ─── Ready box click router ───────────────────────── */
  function handleReadyClick(boxId) {
    var box = null;
    for (var i = 0; i < CURATED.length; i++) if (CURATED[i].id === boxId) { box = CURATED[i]; break; }
    if (!box) return;
    if (box.blocked || !box.available) {
      openNotifyModal(box);
      return;
    }
    // Sellable curated box → prefill step riepilogo
    state.boxMode = 'curated:' + box.id;
    state.occasion = box.occasion || null;
    // Map level by price range
    if (box.price >= 200) state.level = 'premium';
    else state.level = 'classica';
    // Clear custom items (curated mode replaces them) + variant chip selections
    state.items = {};
    state.expandedProductId = null;
    if (window.__SALIHA_GB_VARIANT_SEL__) window.__SALIHA_GB_VARIANT_SEL__ = {};
    // Add box parent line item (1 line item, full box price)
    if (box.defaultVariantId) {
      state.items[String(box.defaultVariantId)] = {
        qty: 1,
        productId: box.shopifyId,
        productHandle: box.handle,
        name: box.title,
        price: box.price,
        image: box.image,
        variantTitle: 'Default Title',
        isAddon: false,
        isBoxParent: true,
        contents: box.contents || []
      };
    }
    state.step = 4;
    state.expandedProductId = null;
    saveState();
    renderAll();
    var page = document.querySelector('[data-gb-page]');
    if (page) page.scrollIntoView({ behavior: 'smooth', block: 'start' });
    trackEvent('giftbox_ready_selected', { box: box.id });
  }

  /* ─── Notify modal (blocked boxes) ─────────────────── */
  var __notifyOpenerEl = null;

  function openNotifyModal(box) {
    closeNotifyModal();
    __notifyOpenerEl = document.activeElement;
    var html = '<div class="gb-modal-bg" data-gb-modal>' +
      '<div class="gb-modal" role="dialog" aria-modal="true" aria-labelledby="gb-notify-title">' +
        '<button type="button" class="gb-modal__close" data-gb-modal-close aria-label="Chiudi">×</button>' +
        '<p class="gb-modal__eyebrow">✦ Tornano presto</p>' +
        '<h3 class="gb-modal__title" id="gb-notify-title">' + escapeHtml(box.title) + '</h3>' +
        '<p class="gb-modal__sub">Questa box arriverà disponibile a breve. Lasciaci la tua email — sarai la prima a saperlo, niente spam.</p>' +
        '<form class="gb-modal__form" data-gb-notify-form>' +
          '<input type="hidden" name="box" value="' + escapeHtml(box.id) + '">' +
          '<label class="gb-modal__label" for="gb-notify-email">Email</label>' +
          '<input class="gb-modal__input" id="gb-notify-email" type="email" name="email" required placeholder="tua@email.it" autocomplete="email">' +
          '<button type="submit" class="gb-modal__cta">Avvisami quando torna</button>' +
          '<p class="gb-modal__legal">Iscrivendoti accetti la <a href="/policies/privacy-policy">privacy policy</a>.</p>' +
        '</form>' +
        '<p class="gb-modal__success" data-gb-notify-success hidden>✓  Grazie, ti scriviamo appena torna.</p>' +
        '<p class="gb-modal__error" data-gb-notify-error hidden>Invio non riuscito. Controlla la connessione e riprova.</p>' +
      '</div>' +
    '</div>';
    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    document.body.appendChild(wrapper.firstChild);
    document.body.style.overflow = 'hidden';
    // Mark page inert so keyboard focus is trapped to modal
    var pageEl = document.querySelector('.gb-page');
    if (pageEl && 'inert' in pageEl) pageEl.inert = true;
    var input = document.getElementById('gb-notify-email');
    if (input) setTimeout(function() { input.focus(); }, 50);
    trackEvent('giftbox_notify_opened', { box: box.id });
  }

  function closeNotifyModal() {
    var existing = document.querySelector('[data-gb-modal]');
    if (existing) existing.remove();
    document.body.style.overflow = '';
    var pageEl = document.querySelector('.gb-page');
    if (pageEl && 'inert' in pageEl) pageEl.inert = false;
    if (__notifyOpenerEl && typeof __notifyOpenerEl.focus === 'function') {
      try { __notifyOpenerEl.focus(); } catch (e) {}
    }
    __notifyOpenerEl = null;
  }

  function submitNotifyForm(form) {
    var emailEl = form.querySelector('input[name="email"]');
    var boxEl = form.querySelector('input[name="box"]');
    if (!emailEl || !emailEl.value || !emailEl.checkValidity()) {
      if (emailEl) emailEl.focus();
      return;
    }
    var email = emailEl.value.trim();
    var boxId = boxEl ? boxEl.value : '';
    // Dispatch event for Klaviyo / external integration to subscribe
    try {
      document.dispatchEvent(new CustomEvent('saliha:giftbox:notify', {
        detail: { email: email, box: boxId }
      }));
    } catch (e) {}
    // POST a /contact: successo mostrato SOLO se la risposta è ok,
    // altrimenti il form resta visibile con messaggio di errore.
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', 'giftbox-notify-' + boxId);
    var errorEl = form.parentNode.querySelector('[data-gb-notify-error]');
    if (errorEl) errorEl.setAttribute('hidden', '');
    var notifyBtn = form.querySelector('button[type="submit"]');
    if (notifyBtn) {
      if (notifyBtn.disabled) return; /* richiesta già in volo */
      notifyBtn.disabled = true;
    }
    fetch('/contact', { method: 'POST', body: fd })
      .then(function (res) {
        if (!res.ok) throw new Error('contact ' + res.status);
        var success = form.parentNode.querySelector('[data-gb-notify-success]');
        if (success) {
          form.style.display = 'none';
          success.removeAttribute('hidden');
        }
        trackEvent('giftbox_notify_submitted', { box: boxId });
        setTimeout(closeNotifyModal, 2000);
      })
      .catch(function () {
        if (notifyBtn) notifyBtn.disabled = false;
        if (errorEl) errorEl.removeAttribute('hidden');
      });
  }

  /* ─── Resume banner ────────────────────────────────── */
  function dismissResume() {
    hasResumeSnapshot = false;
    clearStorage();
    renderResumeBanner();
  }
  function applyResume() {
    if (resumeFromSnapshot()) {
      hasResumeSnapshot = false;
      renderAll();
      var page = document.querySelector('[data-gb-page]');
      if (page) page.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /* ─── Cart submit ──────────────────────────────────── */
  var isSubmitting = false;

  function showCartError(msg) {
    var el = document.querySelector('[data-gb-cart-error]');
    if (el) {
      el.textContent = msg || 'Si è verificato un errore. Riprova fra qualche istante.';
      el.removeAttribute('hidden');
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    isSubmitting = false;
    setSubmitButtonsLoading(false);
  }
  function clearCartError() {
    var el = document.querySelector('[data-gb-cart-error]');
    if (el) { el.textContent = ''; el.setAttribute('hidden', ''); }
  }
  function setSubmitButtonsLoading(loading) {
    document.querySelectorAll('[data-gb-cart-btn]').forEach(function(btn) {
      btn.disabled = loading;
      if (loading) {
        btn.setAttribute('data-loading', 'true');
        if (!btn.getAttribute('data-original-label')) {
          btn.setAttribute('data-original-label', btn.innerHTML);
        }
        btn.innerHTML = '✦  Aggiunta in corso…';
      } else {
        btn.removeAttribute('data-loading');
        var original = btn.getAttribute('data-original-label');
        if (original) btn.innerHTML = original;
      }
    });
    /* dopo il restore, riapplica i gate (msgOk / count / modalità sidebar):
       il disabled=false incondizionato qui sopra non deve sopravvivere */
    if (!loading) { try { renderStep5(); } catch (e) {} }
  }
  async function rollbackCart() {
    try { await fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } }); }
    catch (e) { console.warn('[saliha-gb] rollback failed:', e); }
  }
  async function fetchWithTimeout(url, opts, timeoutMs) {
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timeoutId;
    if (ctrl) {
      timeoutId = setTimeout(function() { ctrl.abort(); }, timeoutMs || 15000);
      opts = Object.assign({}, opts, { signal: ctrl.signal });
    }
    try { return await fetch(url, opts); }
    finally { if (timeoutId) clearTimeout(timeoutId); }
  }

  // Guardia /cart/clear: la box sostituisce il carrello (decisione D11) ma MAI
  // senza consenso. Il lock isSubmitting va preso in modo SINCRONO prima di
  // qualsiasi await: un doppio tap non deve né auto-confermare la sostituzione
  // né lanciare due sequenze clear+add concorrenti. La conferma vale solo come
  // gesto distinto: avviso già mostrato da >600ms e da meno di 45s.
  var cartReplaceArmedAt = 0;

  function armaConfermaSostituzione(msg) {
    cartReplaceArmedAt = Date.now();
    showCartError(msg); /* azzera isSubmitting + riabilita i bottoni */
  }

  async function submitBox() {
    if (isSubmitting) return;
    isSubmitting = true;
    if (getItemCount() === 0) {
      showCartError('Seleziona almeno un prodotto prima di aggiungere al carrello.');
      return;
    }
    if (!state.message || !state.message.trim()) {
      showCartError('Scrivi un messaggio per il biglietto prima di continuare.');
      return;
    }
    var confirmAge = Date.now() - cartReplaceArmedAt;
    var confermaValida = cartReplaceArmedAt > 0 && confirmAge > 600 && confirmAge < 45000;
    try {
      var preCartRes = await fetchWithTimeout('/cart.js', { headers: { 'Accept': 'application/json' } }, 8000);
      if (preCartRes.ok) {
        var preCart = await preCartRes.json();
        if (preCart.item_count > 0 && !confermaValida) {
          var n = preCart.item_count;
          armaConfermaSostituzione(
            'Hai già ' + n + (n === 1 ? ' articolo' : ' articoli') + ' nel carrello: aggiungendo la Gift Box ' +
            (n === 1 ? 'verrà rimosso' : 'verranno rimossi') + '. Premi di nuovo il bottone per confermare.'
          );
          return;
        }
      } else if (!confermaValida) {
        // carrello non verificabile → fail-safe: mai svuotare senza consenso
        armaConfermaSostituzione('Non riusciamo a verificare il carrello: aggiungendo la Gift Box l\'eventuale contenuto verrà sostituito. Premi di nuovo il bottone per confermare.');
        return;
      }
    } catch (e) {
      if (!confermaValida) {
        armaConfermaSostituzione('Non riusciamo a verificare il carrello: aggiungendo la Gift Box l\'eventuale contenuto verrà sostituito. Premi di nuovo il bottone per confermare.');
        return;
      }
    }
    cartReplaceArmedAt = 0;
    var clearedExistingItems = false;
    clearCartError();
    setSubmitButtonsLoading(true);

    var occ = getCurrentOccasion();
    var lvl = getCurrentLevel();
    var box = getCuratedBox();
    var boxParent = getBoxParentItem();
    var addons = getAddonItems();
    var customs = getCustomItems();

    var groupId = box ? 'curated-' + box.id + '-' + Date.now() : 'custom-' + Date.now();

    // Build base properties applied to ALL line items (so they group at cart)
    var baseProps = {};
    baseProps['__gift_box'] = groupId;
    if (box) {
      baseProps['Box'] = box.title;
    } else {
      baseProps['Box'] = 'Box su misura SALIHA';
    }
    if (state.occasion === 'altro' && state.occasionOther && state.occasionOther.trim()) {
      baseProps['Occasione'] = sanitizeCartProp(state.occasionOther, 60);
    } else if (occ) {
      baseProps['Occasione'] = occ.label;
    }
    if (lvl && !box) baseProps['Tipo'] = lvl.label;
    var sRec = sanitizeCartProp(state.recipient, 60);
    var sFrom = sanitizeCartProp(state.from, 60);
    var sMsg = sanitizeCartProp(state.message, 200);
    if (sRec) baseProps['Per'] = sRec;
    if (sFrom) baseProps['Da'] = sFrom;
    if (sMsg) baseProps['Messaggio'] = sMsg;

    try {
      // 1. Clear existing cart
      var clearRes = await fetchWithTimeout('/cart/clear.js', {
        method: 'POST', headers: { 'Accept': 'application/json' }
      }, 10000);
      if (!clearRes.ok) throw new Error('Impossibile svuotare il carrello esistente.');
      clearedExistingItems = true;

      // 2. Sequence: box parent (if curated) → addon items → custom items
      var sequence = [];
      if (boxParent) {
        var bpProps = Object.assign({}, baseProps);
        if (box && box.contents) {
          var contentsLines = box.contents.map(function(c) {
            return '• ' + c.label + (c.qty && c.qty > 1 ? ' ×' + c.qty : '');
          });
          bpProps['Contenuto box'] = contentsLines.join('\n');
        }
        sequence.push({ item: boxParent, props: bpProps });
      }
      addons.forEach(function(it) {
        sequence.push({ item: it, props: Object.assign({}, baseProps, { 'Tipo riga': 'Aggiunta personale' }) });
      });
      customs.forEach(function(it) {
        sequence.push({ item: it, props: Object.assign({}, baseProps) });
      });
      // Riga supplemento confezione (solo box su misura; le box curate sono già a prezzo pieno → surcharge 0)
      var pkgSurcharge = getPackagingSurcharge();
      if (pkgSurcharge > 0 && state.level && PACKAGING[state.level] && PACKAGING[state.level].variantId) {
        sequence.push({
          item: { variantId: PACKAGING[state.level].variantId, qty: 1, name: 'Confezione ' + (lvl ? lvl.label : '') },
          props: Object.assign({}, baseProps, { 'Tipo riga': 'Confezione' })
        });
      }

      for (var i = 0; i < sequence.length; i++) {
        var s = sequence[i];
        var it = s.item;
        var addRes = await fetchWithTimeout('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(it.variantId, 10),
            quantity: it.qty || 1,
            properties: s.props
          })
        }, 15000);
        if (!addRes.ok) {
          var errBody = await addRes.json().catch(function() { return null; });
          var errMsg = (errBody && (errBody.description || errBody.message)) || 'Prodotto non disponibile.';
          await rollbackCart();
          throw new Error((it.name || 'Prodotto') + ': ' + errMsg);
        }
      }

      // 3. Update cart attributes — minimal audit key only (avoid duplicating
      //    line-item properties at cart-attribute scope, which can leak into
      //    order notes and pollute the dashboard)
      var attrs = { gift_box_group: groupId };
      var updateRes = await fetchWithTimeout('/cart/update.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }, 10000);
      if (!updateRes.ok) {
        console.warn('[saliha-gb] update.js attrs failed:', updateRes.status);
      }

      // 4. Track + clear localStorage + redirect
      trackEvent('giftbox_add_to_cart', {
        groupId: groupId,
        boxId: box ? box.id : null,
        itemCount: sequence.length,
        total: getItemTotal()
      });
      clearStorage();
      window.location.href = '/cart';

    } catch (err) {
      console.error('[saliha-gb] submitBox error:', err);
      var prefix = clearedExistingItems ? 'Il carrello è stato svuotato. ' : '';
      if (err && err.name === 'AbortError') {
        await rollbackCart();
        showCartError('Connessione lenta. ' + prefix + 'Riprova fra qualche istante.');
      } else {
        showCartError(prefix + (err && err.message ? err.message : 'Errore durante l\'aggiunta al carrello.'));
      }
    }
  }

  /* Reset isSubmitting on bfcache restore (iOS Safari) */
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      isSubmitting = false;
      setSubmitButtonsLoading(false);
    }
  });

  /* ─── Analytics ────────────────────────────────────── */
  function trackEvent(name, params) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: name }, params || {}));
      }
    } catch (e) {}
  }

  /* ─── Event handlers ───────────────────────────────── */
  function handleClick(e) {
    var sheetToggle = e.target.closest('[data-gb-sheet-toggle]');
    if (sheetToggle) { toggleMobileSheet(); return; }
    var sheetSummary = e.target.closest('[data-gb-sheet-summary]');
    if (sheetSummary) { closeMobileSheet(); setStep(4); return; }
    var sheetBackdrop = e.target.closest('[data-gb-sheet-backdrop]');
    if (sheetBackdrop) { closeMobileSheet(); return; }

    var stepBtn = e.target.closest('[data-gb-step-btn]');
    if (stepBtn) { setStep(parseInt(stepBtn.getAttribute('data-gb-step-btn'), 10)); return; }

    var nextBtn = e.target.closest('[data-gb-next]');
    if (nextBtn && !nextBtn.disabled) {
      var n = parseInt(nextBtn.getAttribute('data-gb-next'), 10);
      setStep(n + 1); return;
    }

    var backBtn = e.target.closest('[data-gb-back]');
    if (backBtn) {
      var b = parseInt(backBtn.getAttribute('data-gb-back'), 10);
      setStep(Math.max(1, b - 1)); return;
    }

    var occBtn = e.target.closest('[data-gb-occasion]');
    if (occBtn) {
      var id = occBtn.getAttribute('data-gb-occasion');
      var wasSelected = state.occasion === id;
      state.occasion = wasSelected ? null : id;
      if (state.occasion !== 'altro') state.occasionOther = '';
      state.boxMode = 'custom';
      saveState();
      // Auto-advance al Tipo Box (step 2) — eccetto 'altro' (serve l'input libero)
      if (!wasSelected && state.occasion && state.occasion !== 'altro') { setStep(2); return; }
      // 'altro' o riselezione (toggle-off): resta nello step 1
      renderStep1(); renderSidebar(); renderMobileStrip();
      return;
    }

    var lvlBtn = e.target.closest('[data-gb-level]');
    if (lvlBtn) {
      var lid = lvlBtn.getAttribute('data-gb-level');
      var lvlWasSelected = state.level === lid;
      state.level = lvlWasSelected ? null : lid;
      state.boxMode = 'custom';
      saveState();
      // Auto-advance ai prodotti (step 3) quando si sceglie un livello
      if (!lvlWasSelected && state.level) { setStep(3); return; }
      // Riselezione (toggle-off): resta nello step 2
      renderStep2(); renderSidebar(); renderMobileStrip();
      return;
    }

    var catBtn = e.target.closest('[data-gb-cat]');
    if (catBtn) {
      state.activeCategory = catBtn.getAttribute('data-gb-cat');
      saveState(); renderStep3();
      return;
    }

    var expandBtn = e.target.closest('[data-gb-expand]');
    if (expandBtn && !expandBtn.disabled) {
      var pid = expandBtn.getAttribute('data-gb-expand');
      state.expandedProductId = (state.expandedProductId === pid) ? null : pid;
      saveState(); renderStep3();
      return;
    }

    var vchip = e.target.closest('[data-gb-vchip]');
    if (vchip && !vchip.disabled) {
      toggleVariantChip(vchip.getAttribute('data-gb-vchip'), parseInt(vchip.getAttribute('data-gb-vdim'), 10), vchip.getAttribute('data-gb-vval'));
      return;
    }

    var addVar = e.target.closest('[data-gb-add-variant]');
    if (addVar && !addVar.disabled) {
      addProductVariant(addVar.getAttribute('data-gb-add-variant'), { asAddon: false });
      return;
    }
    var addVarAddon = e.target.closest('[data-gb-add-variant-addon]');
    if (addVarAddon && !addVarAddon.disabled) {
      addProductVariant(addVarAddon.getAttribute('data-gb-add-variant-addon'), { asAddon: true });
      return;
    }

    var addBtn = e.target.closest('[data-gb-add]');
    if (addBtn && !addBtn.disabled) {
      addProduct(addBtn.getAttribute('data-gb-add'), { asAddon: false });
      return;
    }
    var addAddon = e.target.closest('[data-gb-add-addon]');
    if (addAddon && !addAddon.disabled) {
      addProduct(addAddon.getAttribute('data-gb-add-addon'), { asAddon: true });
      return;
    }

    var rmBtn = e.target.closest('[data-gb-remove]');
    if (rmBtn) { removeProduct(rmBtn.getAttribute('data-gb-remove'), { asAddon: false }); return; }
    var rmAddon = e.target.closest('[data-gb-remove-addon]');
    if (rmAddon) { removeProduct(rmAddon.getAttribute('data-gb-remove-addon'), { asAddon: true }); return; }

    var readyClick = e.target.closest('[data-gb-ready-click]');
    if (readyClick) { handleReadyClick(readyClick.getAttribute('data-gb-ready-click')); return; }

    var notifyBtn = e.target.closest('[data-gb-notify]');
    if (notifyBtn) {
      var notifyId = notifyBtn.getAttribute('data-gb-notify');
      var box = null;
      for (var i = 0; i < CURATED.length; i++) if (CURATED[i].id === notifyId) { box = CURATED[i]; break; }
      if (box) openNotifyModal(box);
      return;
    }

    var modalClose = e.target.closest('[data-gb-modal-close]');
    if (modalClose) { closeNotifyModal(); return; }
    var modalBg = e.target.closest('[data-gb-modal]');
    if (modalBg && e.target === modalBg) { closeNotifyModal(); return; }

    var resumeApply = e.target.closest('[data-gb-resume-apply]');
    if (resumeApply) { applyResume(); return; }
    var resumeDismiss = e.target.closest('[data-gb-resume-dismiss]');
    if (resumeDismiss) { dismissResume(); return; }

    var cartBtn = e.target.closest('[data-gb-cart-btn], [data-gb-strip-cta]');
    if (cartBtn) {
      var mode = cartBtn.getAttribute('data-mode') || 'cart';
      if (cartBtn.matches('[data-gb-strip-cta]')) {
        if (mode === 'continue') {
          var nextStep = (!state.occasion ? 1 : !state.level ? 2 : (getItemCount() === 0 ? 3 : 4));
          setStep(nextStep);
          return;
        }
        if (mode === 'summary') { setStep(4); return; }
      }
      if (mode === 'summary') { setStep(4); return; }
      if (cartBtn.disabled) return;
      e.preventDefault();
      submitBox();
      return;
    }
  }

  function handleChange(e) {}

  function handleInput(e) {
    var t = e.target;
    if (t.matches('[data-gb-occasion-other]')) { state.occasionOther = t.value; saveState(); renderStep1(); return; }
    if (t.matches('[data-gb-name]')) { state.recipient = t.value; saveState(); renderStep5(); return; }
    if (t.matches('[data-gb-message]')) { state.message = t.value; saveState(); renderStep5(); return; }
    if (t.matches('[data-gb-from]')) { state.from = t.value; saveState(); renderStep5(); return; }
  }

  function handleSubmit(e) {
    var form = e.target.closest('[data-gb-notify-form]');
    if (form) { e.preventDefault(); submitNotifyForm(form); return; }
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') {
      if (document.querySelector('[data-gb-modal]')) { closeNotifyModal(); return; }
      if (__sheetOpen) { closeMobileSheet(); return; }
    }
  }

  function bindEvents() {
    document.addEventListener('click', handleClick);
    document.addEventListener('change', handleChange);
    document.addEventListener('input', handleInput);
    document.addEventListener('submit', handleSubmit);
    document.addEventListener('keydown', handleKeydown);
  }

  /* ─── Init ─────────────────────────────────────────── */
  function init() {
    var page = document.querySelector('[data-gb-page]');
    if (!page) { console.warn('[saliha-gb] [data-gb-page] not found'); return; }
    loadState();
    bindEvents();
    renderAll();
    // Release the paint gate (panels become visible after first render)
    page.removeAttribute('aria-busy');
    console.log('[saliha-gb] ' + VERSION + ' init OK · step=' + state.step + ' · products=' + PRODUCTS.length + ' · curated=' + CURATED.length + ' · resumeAvailable=' + hasResumeSnapshot);
  }

  window.SALIHA_GB = {
    version: VERSION,
    state: state,
    OCCASIONS: OCCASIONS, LEVELS: LEVELS, PRODUCTS: PRODUCTS, CURATED: CURATED, CATEGORIES: CATEGORIES,
    PRESETS: PRESETS,
    setStep: setStep, saveState: saveState, renderAll: renderAll,
    handleReadyClick: handleReadyClick, openNotifyModal: openNotifyModal,
    _internal: { getItemArray: getItemArray, getItemCount: getItemCount, getItemTotal: getItemTotal, getCuratedBox: getCuratedBox }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
